import UserProfileName from "./UserProfileName";

export default UserProfileName;
